type GetBlockErrorMessageParams = {
  blockCode: string;
  mainAccountEmail?: string;
  t: (...params: unknown[]) => string;
};

export const getBlockErrorMessage = ({
  blockCode,
  mainAccountEmail,
  t
}: GetBlockErrorMessageParams) => {
  if (blockCode !== 'multi_acc') {
    return `web.login.error.${blockCode}`;
  }

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: t(`web.login.error.${blockCode}`, [
          `<strong key="blockCode">${mainAccountEmail}</strong>`
        ])
      }}
    />
  );
};
